import React from 'react';
import {Form} from "react-bootstrap";

import CustomTooltip from "../CustomTooltip";

import './SelectedFile.css';

const FILE_TYPE_PDF = 'application/pdf';
const FILE_TYPE_HTML = 'text/html';

const FILE_ICONS = {
    [FILE_TYPE_HTML]: 'html-file.png',
    [FILE_TYPE_PDF]: 'pdf-file.png',
    'application/zip': 'zip-folder.png',
    'application/octet-stream': 'zip-folder.png'
}

const SelectedFile = ({file, className = '', onRemove, leftAlign, disableProFeatures = true, disableExportPdf, disableExportPdfChange}) => {
    const icon = FILE_ICONS[file.type] || 'zip-folder.png'

    return <>
        <div className={`selected-file-container ${className}`}>
            <div className={`zip-file ${leftAlign ? 'left-align' : ''}`}>
                <img
                    className="zip-icon"
                    src={`assets/icons/${icon}`}
                    alt="Zip"
                />
                <span className="text-break font-20">{file.path}</span>
                {
                    file.type === FILE_TYPE_HTML &&
                    <CustomTooltip label="Will be used as your site's homepage (index.html)">
                        <img className="ms-2 me-3" src="assets/icons/info.svg" height="15"/>
                    </CustomTooltip>
                }
                <div
                    className="cursor-pointer d-inline ms-3"
                    onClick={onRemove}
                >
                    <img
                        className="icon-delete"
                        src="delete.png"
                        alt="delete"
                        height="12"
                    />
                </div>
            </div>
            {
                file.type === FILE_TYPE_HTML &&
                <div className={`${leftAlign ? 'text-start' : 'text-center'} font-small grey mt-2`}>
                    Need to upload more files? Upload a zip file instead.
                </div>
            }
            {
                file.type === FILE_TYPE_PDF &&
                <div className="flex mt-4">
                    <Form.Check
                      checked={disableExportPdf}
                      id="disable-export-pdf"
                      className="m-auto"
                      type="switch"
                      label={
                        <CustomTooltip label={`Disables the ability for viewers to download your PDF ${disableProFeatures ? '(Solo/Pro account required)' : ''}`}>
                            <span>
                                Disable downloads {' '}
                                {disableProFeatures && <img alt="Pro" src="assets/icons/pro-black.png" height="20" />}
                            </span>
                        </CustomTooltip>
                      }
                      onChange={disableExportPdfChange}
                      disabled={disableProFeatures}
                    />
                </div>
            }
        </div>
    </>
}

export default SelectedFile;
